import { render, staticRenderFns } from "./EllipsisScroller.vue?vue&type=template&id=17b8ae0c&scoped=true&"
import script from "./EllipsisScroller.vue?vue&type=script&lang=ts&"
export * from "./EllipsisScroller.vue?vue&type=script&lang=ts&"
import style0 from "./EllipsisScroller.vue?vue&type=style&index=0&id=17b8ae0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b8ae0c",
  null
  
)

export default component.exports